'use client';

import {
  Stack,
  Text,
  HStack,
  Grid,
} from '@chakra-ui/react';

interface FeatureListEditorProps {
  /**
   * List of benefits
   */
  benefits?: string[] | null;
}

/**
 * A specialized editor component for managing feature lists
 */
export const LegacyBenefits = ({ benefits }: FeatureListEditorProps) => {
  if (!benefits || benefits.length === 0) {
    return null;
  }

  // Split benefits into two independent columns
  const midpoint = Math.ceil(benefits.length / 2);
  const firstColumn = benefits.slice(0, midpoint);
  const secondColumn = benefits.slice(midpoint);

  return (
    <Stack
      spacing="4"
      pb={{ mobile: 0, desktop: 4 }}
      pt={{ mobile: 0, desktop: 6 }}
    >
      <Grid templateColumns="1fr 1fr" gap="4">
        {/* First column */}
        <Stack spacing="2">
          {firstColumn.map((benefit, index) => (
            <HStack key={index} align="top" spacing="3">
              <Text size="md" color="blackAlpha.700">
                •
              </Text>
              <Text size="md" color="blackAlpha.700" whiteSpace="pre-wrap">
                {benefit}
              </Text>
            </HStack>
          ))}
        </Stack>

        {/* Second column */}
        <Stack spacing="2">
          {secondColumn.map((benefit, index) => (
            <HStack key={index} align="top" spacing="3">
              <Text size="md" color="blackAlpha.700">
                •
              </Text>
              <Text size="md" color="blackAlpha.700" whiteSpace="pre-wrap">
                {benefit}
              </Text>
            </HStack>
          ))}
        </Stack>
      </Grid>
    </Stack>
  );
};
